import React, { useEffect } from "react";
import Highcharts from "highcharts";
require("highcharts/modules/accessibility")(Highcharts);

export default function DemandAnalysis({ summaryReports }) {
    function getLevelsText(summaryReports) {
        const levels = [];
        if (summaryReports?.optionsAvailable?.REGULAR) levels.push("Regular");
        if (summaryReports?.optionsAvailable?.MIDGRADE) levels.push("Midgrade");
        if (summaryReports?.optionsAvailable?.PREMIUM) levels.push("Premium");

        if (levels.length === 0) return "";
        if (levels.length === 2) return `${levels[0]} and ${levels[1]}`;
        if (levels.length > 2) {
            return levels.slice(0, -1).join(", ") + " and " + levels.slice(-1);
        }
        return levels[0];
    }
    function applyDemandVarianceAccessibility(chart) {
        if (chart && chart.renderTo) {
            const svg = chart.renderTo.querySelector("svg");
            if (svg) {
            // role + aria-label
            setTimeout(() => {
            const levelsText = getLevelsText(summaryReports);
            svg.setAttribute("role", "img");
            svg.setAttribute(
                "aria-label",
                `Demand Variance chart comparing forecasted and actual demand for ${levelsText} gasoline types`
            );

            // remove old desc
            const oldDesc = svg.querySelector("desc");
            if (oldDesc) oldDesc.remove();

            // add new desc
            const desc = document.createElementNS("http://www.w3.org/2000/svg", "desc");
            desc.textContent =
                `This chart shows forecasted and actual demand for different gasoline types. ${levelsText} bars are compared side by side to show the variance.`;
            svg.insertBefore(desc, svg.firstChild);
            }, 0);
            }
        }
    }
    
    var chart = {
        type: 'column',
        events: {
            render: function () {
            applyDemandVarianceAccessibility(this);
            },
            redraw: function () {
            applyDemandVarianceAccessibility(this);
            }
        }
    };
    var title = {
        text: "Demand Variance",
        align: "left",
        style: {
            fontSize: "14px",
        },
    };
    var credits = {
        enabled: false, // Disable the Highcharts bottom link
    };
    var tooltip = {
       // format: '<strong>{key}</strong><br/>{series.name}: <strong>{y}</strong><br/>',
        formatter: function () {
            var tooltipText = `<strong>${this.x}</strong>`+ '<br/>';
            if (this.series.name === 'Forecasted Demand') {
              tooltipText += '<span style="color: #BB4A28;">' + this.series.name + '</span>: <strong style="font-weight: bold;">' + Highcharts.numberFormat(this.y, 0, ',', ',') + '</strong>';
            } else if (this.series.name === 'Actual Demand') {
              tooltipText += '<span style="color: #005A70;">' + this.series.name + '</span>: <strong style="font-weight: bold;">' + Highcharts.numberFormat(this.y, 0, ',', ',') + '</strong>';
            }
            return tooltipText;
          },
        borderWidth: 1,
        style: {
            borderColor: function () {
                return this.point.color; // Set the tooltip box border color to match the point color
            },
            opacity: 0.9,
            fontSize: '14px',
        }
    };
    var legend = {
        enabled: false,
        align: "left",
        itemStyle: {
            fontWeight: "bold",
            fontSize: "11px",
        },
    };

    var plotOptions = {
        column: {

            dataLabels: {
                enabled: false,
                style: {
                    textOutline: "none",
                },
            },
        },
        series:{
            events: {
                legendItemClick: function() {
                    return false;
                }
              }
        }
    };
    var series = [
        {
            name: "Forecasted Demand",
            data: [],
            //color: "#BB4A28",
            color: {
                pattern: {
                  path: 'M 0 0 L 10 10 M 0 10 L 10 0', // Diagonal cross pattern
                  width: 10,
                  height: 10,
                  color: "#BB4A28",
                }
              }
        },
        {
            name: "Actual Demand",
            data: [],
            //color: "#005A70",
            color: {
                pattern: {
                    path: 'M 0 5 L 10 5', // Horizontal line
                    width: 10,
                    height: 10,
                    color: '#FFFFFF', // Line color (white)
                    backgroundColor: '#005A70' 
                }
            },
        }
    ];
    var xAxis = {
        categories: [],
        title: {
            text: "Gasoline Type",
        },
        lineColor: '#EFEFEC'
    }
    var yAxis = {
        allowDecimals: false,
        crosshair: true,
        min: 0,
        title: {
            text: 'Demand'
        }
    }
    var accessibility = {
        enabled: true,
        screenReaderSection: {
            beforeChartFormat: '' // disables the default label
        }
    };
    var json = {};
    json.chart = chart;
    json.credits = credits;
    json.title = title;
    json.tooltip = tooltip;
    json.legend = legend;
    json.series = series;
    json.xAxis = xAxis;
    json.yAxis = yAxis;
    json.plotOptions = plotOptions;
    json.accessibility = accessibility;
    const initGraph = () => {
        // debugger;
        let xAxisCategories = []
        let series0Data = []
        let series1Data = []
        for (const key in summaryReports?.optionsAvailable) {
            if (summaryReports?.optionsAvailable[key]) {
              xAxisCategories.push(key);
              series0Data.push(summaryReports?.DemandAnalysis?.forecastedDemands[key])
              series1Data.push(summaryReports?.DemandAnalysis?.actualDemands[key])
            }
        }
        json.xAxis.categories = xAxisCategories;
        json.series[0].data = series0Data
        json.series[1].data = series1Data
        Highcharts.chart("DemandAnalysis", json);
        //console.log(json);
    };
    useEffect(() => {
        initGraph();
    }, [summaryReports]);
    return (
        <div
            id="DemandAnalysis"
            style={{ height: "340px" }}
            title={title.text}
            aria-label="Cost Analysis Graph"
            className="costAnalysis"
        ></div>
    );
}
